import React from "react"

import { useCurrentColorMode } from "./AppThemeContextProvider"

import type { ThemedValue } from "./types"

export function useThemedValue(): <T>(value: ThemedValue<T>) => T
export function useThemedValue<T>(value: ThemedValue<T>): T
export function useThemedValue<T>(
  initial?: ThemedValue<T>,
): T | ((value: ThemedValue<T>) => T) {
  const colorMode = useCurrentColorMode()

  const getValue = React.useCallback(
    (value: ThemedValue<T>) => {
      if (typeof value === "object" && "light" in value) {
        return value[colorMode]
      }
      return value
    },
    [colorMode],
  )
  if (typeof initial === "undefined") {
    return getValue
  }
  return getValue(initial)
}
